//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from "./components/header/hearer";
import Menu from "./components/menu/menu";
import SysContentHeader from "./components/sys-content-header/sys-content-header";
import { mapState, mapMutations } from "vuex";
export default {
  name: "app",
  data() {
    return {
      menuId: "",
      isCollapse: false,
    };
  },
  methods: {
    thatUrl(to) {
      if (to) {
        if (to.matched[0]) {
          const name = to.matched[0].components.default.name;
          const routerTag = {
            url: to.path,
            name: to.name,
            componentsName: name,
            englishName:
              to.meta && to.meta.menuData && to.meta.menuData.englishName
                ? to.meta.menuData.englishName
                : "",
          };
          if (routerTag.url !== "/login") {
            this.SET_GOROUTER(routerTag);
          }
        }
        if (to.meta.menuData) {
          this.menuId = to.meta.menuData.menuIndex;
        }
        this.SET_TODATE(to);
      }
    },
    ...mapMutations(["SET_GOROUTER", "SET_TODATE"]),
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "thatUrl",
  },
  mounted() {
    this.thatUrl(this.$route);
  },
  components: {
    "pi-header": Header,
    "pi-menu": Menu,
    "sys-content-header": SysContentHeader,
    // "pi-div-scroll": divScroll
  },
  computed: {
    ...mapState(["sys"]),
  },
};
